import { all, takeEvery, put, call } from 'redux-saga/effects'
import adminApi from 'services/admin'
import { actions } from './actions'

export function* loadMainTopic(topicId) {
  try {
    const response = yield call(adminApi.getMainTopic, topicId.payload)

    yield put({
      type: actions.LOAD_MAIN_TOPIC_RESULT,
      payload: response,
    })
  } catch (error) {
    yield put({
      type: actions.LOAD_MAIN_TOPIC_RESULT,
      error,
    })
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_MAIN_TOPIC_REQUEST, loadMainTopic)])
}
